import React from "react";

export default function DisplayMusic({ userData }) {
	return (
		<div className="mb-3">
			<p className="mt-2">
				<i className="bi bi-music-note-beamed"></i> <span>Music</span>
			</p>

			{userData?.music?.map((music, i) => (
				<span key={i} className="badge custom-badge rounded-pill text-bg-secondary me-2 mb-1">
					<i className="bi bi-music-note-beamed"></i> {music}
				</span>
			))}

			{!userData?.music?.length && <div>(Add your music taste)</div>}
		</div>
	);
}
